import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/reminder-sw.js')
      .catch((error) => console.warn('Reminder service worker registration failed:', error));
  });
}

ReactDOM.render(
  // <React.StrictMode>
    <App />,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
